/* tslint:disable */
/* eslint-disable */
/**
 * HR Recruiter API — Reports
 * OpenAPI спецификация для генерации PDF-отчётов по собеседованиям. Самодостаточный файл для генерации и документации. 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@hr-recruiter.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Стандартный ответ об ошибке
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * Сообщение об ошибке
     * @type {string}
     * @memberof ErrorResponse
     */
    'message': string;
    /**
     * Список ошибок валидации
     * @type {Array<string>}
     * @memberof ErrorResponse
     */
    'errors'?: Array<string>;
}

/**
 * ReportsApi - axios parameter creator
 * @export
 */
export const ReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Генерирует PDF-отчёт с результатами конкретного собеседования. Включает информацию о кандидате, позиции, ответах и оценках ИИ. Изоляция данных происходит автоматически через JWT токен. 
         * @summary Получить PDF-отчёт результата собеседования
         * @param {number} interviewId ID собеседования
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterviewResultReport: async (interviewId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interviewId' is not null or undefined
            assertParamExists('getInterviewResultReport', 'interviewId', interviewId)
            const localVarPath = `/reports/interviews/{interviewId}/result`
                .replace(`{${"interviewId"}}`, encodeURIComponent(String(interviewId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Генерирует PDF-отчёт со списком собеседований по заданным фильтрам. Поддерживает все фильтры из поиска собеседований плюс фильтр по вакансии. Изоляция данных происходит автоматически через JWT токен. 
         * @summary Получить PDF-отчёт-список собеседований
         * @param {number} [positionId] Фильтр по ID вакансии
         * @param {number} [candidateId] Фильтр по ID кандидата
         * @param {GetInterviewsListReportStatus} [status] Фильтр по статусу собеседования
         * @param {GetInterviewsListReportResult} [result] Фильтр по результату собеседования
         * @param {string} [search] Поиск по названию вакансии, имени, фамилии, email кандидата
         * @param {number} [page] Номер страницы (начиная с 0)
         * @param {number} [size] Размер страницы
         * @param {string} [sort] Сортировка в формате \&quot;поле,направление\&quot;
         * @param {number} [maxRows] Верхний предел строк в отчёте для защиты от чрезмерных нагрузок
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterviewsListReport: async (positionId?: number, candidateId?: number, status?: GetInterviewsListReportStatus, result?: GetInterviewsListReportResult, search?: string, page?: number, size?: number, sort?: string, maxRows?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reports/interviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }

            if (candidateId !== undefined) {
                localVarQueryParameter['candidateId'] = candidateId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (result !== undefined) {
                localVarQueryParameter['result'] = result;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (maxRows !== undefined) {
                localVarQueryParameter['maxRows'] = maxRows;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Генерирует PDF-отчёт по тем же данным, которые отображаются на экране \"Итоги подбора\": успешные AI-кандидаты с учётом проходного балла и успешные live-кандидаты из интеграции AiRecruiter. Generic-отчёт /reports/interviews не используется, чтобы в PDF не попадали неуспешные или незавершённые собеседования. 
         * @summary Получить PDF-отчёт итогов подбора
         * @param {GetRecruitmentResultsReportPeriod} [period] Период статистики, совпадает с фильтром итогов подбора
         * @param {string} [search] Поиск по кандидату, email или вакансии
         * @param {number} [positionId] Фильтр по ID вакансии
         * @param {number} [maxRows] Верхний предел строк в отчёте для защиты от чрезмерных нагрузок
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruitmentResultsReport: async (period?: GetRecruitmentResultsReportPeriod, search?: string, positionId?: number, maxRows?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reports/recruitment-results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }

            if (maxRows !== undefined) {
                localVarQueryParameter['maxRows'] = maxRows;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportsApi - functional programming interface
 * @export
 */
export const ReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * Генерирует PDF-отчёт с результатами конкретного собеседования. Включает информацию о кандидате, позиции, ответах и оценках ИИ. Изоляция данных происходит автоматически через JWT токен. 
         * @summary Получить PDF-отчёт результата собеседования
         * @param {number} interviewId ID собеседования
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInterviewResultReport(interviewId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInterviewResultReport(interviewId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getInterviewResultReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Генерирует PDF-отчёт со списком собеседований по заданным фильтрам. Поддерживает все фильтры из поиска собеседований плюс фильтр по вакансии. Изоляция данных происходит автоматически через JWT токен. 
         * @summary Получить PDF-отчёт-список собеседований
         * @param {number} [positionId] Фильтр по ID вакансии
         * @param {number} [candidateId] Фильтр по ID кандидата
         * @param {GetInterviewsListReportStatus} [status] Фильтр по статусу собеседования
         * @param {GetInterviewsListReportResult} [result] Фильтр по результату собеседования
         * @param {string} [search] Поиск по названию вакансии, имени, фамилии, email кандидата
         * @param {number} [page] Номер страницы (начиная с 0)
         * @param {number} [size] Размер страницы
         * @param {string} [sort] Сортировка в формате \&quot;поле,направление\&quot;
         * @param {number} [maxRows] Верхний предел строк в отчёте для защиты от чрезмерных нагрузок
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInterviewsListReport(positionId?: number, candidateId?: number, status?: GetInterviewsListReportStatus, result?: GetInterviewsListReportResult, search?: string, page?: number, size?: number, sort?: string, maxRows?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInterviewsListReport(positionId, candidateId, status, result, search, page, size, sort, maxRows, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getInterviewsListReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Генерирует PDF-отчёт по тем же данным, которые отображаются на экране \"Итоги подбора\": успешные AI-кандидаты с учётом проходного балла и успешные live-кандидаты из интеграции AiRecruiter. Generic-отчёт /reports/interviews не используется, чтобы в PDF не попадали неуспешные или незавершённые собеседования. 
         * @summary Получить PDF-отчёт итогов подбора
         * @param {GetRecruitmentResultsReportPeriod} [period] Период статистики, совпадает с фильтром итогов подбора
         * @param {string} [search] Поиск по кандидату, email или вакансии
         * @param {number} [positionId] Фильтр по ID вакансии
         * @param {number} [maxRows] Верхний предел строк в отчёте для защиты от чрезмерных нагрузок
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecruitmentResultsReport(period?: GetRecruitmentResultsReportPeriod, search?: string, positionId?: number, maxRows?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecruitmentResultsReport(period, search, positionId, maxRows, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getRecruitmentResultsReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportsApi - factory interface
 * @export
 */
export const ReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportsApiFp(configuration)
    return {
        /**
         * Генерирует PDF-отчёт с результатами конкретного собеседования. Включает информацию о кандидате, позиции, ответах и оценках ИИ. Изоляция данных происходит автоматически через JWT токен. 
         * @summary Получить PDF-отчёт результата собеседования
         * @param {number} interviewId ID собеседования
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterviewResultReport(interviewId: number, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getInterviewResultReport(interviewId, options).then((request) => request(axios, basePath));
        },
        /**
         * Генерирует PDF-отчёт со списком собеседований по заданным фильтрам. Поддерживает все фильтры из поиска собеседований плюс фильтр по вакансии. Изоляция данных происходит автоматически через JWT токен. 
         * @summary Получить PDF-отчёт-список собеседований
         * @param {number} [positionId] Фильтр по ID вакансии
         * @param {number} [candidateId] Фильтр по ID кандидата
         * @param {GetInterviewsListReportStatus} [status] Фильтр по статусу собеседования
         * @param {GetInterviewsListReportResult} [result] Фильтр по результату собеседования
         * @param {string} [search] Поиск по названию вакансии, имени, фамилии, email кандидата
         * @param {number} [page] Номер страницы (начиная с 0)
         * @param {number} [size] Размер страницы
         * @param {string} [sort] Сортировка в формате \&quot;поле,направление\&quot;
         * @param {number} [maxRows] Верхний предел строк в отчёте для защиты от чрезмерных нагрузок
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterviewsListReport(positionId?: number, candidateId?: number, status?: GetInterviewsListReportStatus, result?: GetInterviewsListReportResult, search?: string, page?: number, size?: number, sort?: string, maxRows?: number, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getInterviewsListReport(positionId, candidateId, status, result, search, page, size, sort, maxRows, options).then((request) => request(axios, basePath));
        },
        /**
         * Генерирует PDF-отчёт по тем же данным, которые отображаются на экране \"Итоги подбора\": успешные AI-кандидаты с учётом проходного балла и успешные live-кандидаты из интеграции AiRecruiter. Generic-отчёт /reports/interviews не используется, чтобы в PDF не попадали неуспешные или незавершённые собеседования. 
         * @summary Получить PDF-отчёт итогов подбора
         * @param {GetRecruitmentResultsReportPeriod} [period] Период статистики, совпадает с фильтром итогов подбора
         * @param {string} [search] Поиск по кандидату, email или вакансии
         * @param {number} [positionId] Фильтр по ID вакансии
         * @param {number} [maxRows] Верхний предел строк в отчёте для защиты от чрезмерных нагрузок
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruitmentResultsReport(period?: GetRecruitmentResultsReportPeriod, search?: string, positionId?: number, maxRows?: number, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getRecruitmentResultsReport(period, search, positionId, maxRows, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportsApi - object-oriented interface
 * @export
 * @class ReportsApi
 * @extends {BaseAPI}
 */
export class ReportsApi extends BaseAPI {
    /**
     * Генерирует PDF-отчёт с результатами конкретного собеседования. Включает информацию о кандидате, позиции, ответах и оценках ИИ. Изоляция данных происходит автоматически через JWT токен. 
     * @summary Получить PDF-отчёт результата собеседования
     * @param {number} interviewId ID собеседования
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public getInterviewResultReport(interviewId: number, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).getInterviewResultReport(interviewId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Генерирует PDF-отчёт со списком собеседований по заданным фильтрам. Поддерживает все фильтры из поиска собеседований плюс фильтр по вакансии. Изоляция данных происходит автоматически через JWT токен. 
     * @summary Получить PDF-отчёт-список собеседований
     * @param {number} [positionId] Фильтр по ID вакансии
     * @param {number} [candidateId] Фильтр по ID кандидата
     * @param {GetInterviewsListReportStatus} [status] Фильтр по статусу собеседования
     * @param {GetInterviewsListReportResult} [result] Фильтр по результату собеседования
     * @param {string} [search] Поиск по названию вакансии, имени, фамилии, email кандидата
     * @param {number} [page] Номер страницы (начиная с 0)
     * @param {number} [size] Размер страницы
     * @param {string} [sort] Сортировка в формате \&quot;поле,направление\&quot;
     * @param {number} [maxRows] Верхний предел строк в отчёте для защиты от чрезмерных нагрузок
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public getInterviewsListReport(positionId?: number, candidateId?: number, status?: GetInterviewsListReportStatus, result?: GetInterviewsListReportResult, search?: string, page?: number, size?: number, sort?: string, maxRows?: number, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).getInterviewsListReport(positionId, candidateId, status, result, search, page, size, sort, maxRows, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Генерирует PDF-отчёт по тем же данным, которые отображаются на экране \"Итоги подбора\": успешные AI-кандидаты с учётом проходного балла и успешные live-кандидаты из интеграции AiRecruiter. Generic-отчёт /reports/interviews не используется, чтобы в PDF не попадали неуспешные или незавершённые собеседования. 
     * @summary Получить PDF-отчёт итогов подбора
     * @param {GetRecruitmentResultsReportPeriod} [period] Период статистики, совпадает с фильтром итогов подбора
     * @param {string} [search] Поиск по кандидату, email или вакансии
     * @param {number} [positionId] Фильтр по ID вакансии
     * @param {number} [maxRows] Верхний предел строк в отчёте для защиты от чрезмерных нагрузок
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public getRecruitmentResultsReport(period?: GetRecruitmentResultsReportPeriod, search?: string, positionId?: number, maxRows?: number, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).getRecruitmentResultsReport(period, search, positionId, maxRows, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetInterviewsListReportStatus = {
    NOT_STARTED: 'NOT_STARTED',
    IN_PROGRESS: 'IN_PROGRESS',
    FINISHED: 'FINISHED'
} as const;
export type GetInterviewsListReportStatus = typeof GetInterviewsListReportStatus[keyof typeof GetInterviewsListReportStatus];
/**
 * @export
 */
export const GetInterviewsListReportResult = {
    SUCCESSFUL: 'SUCCESSFUL',
    UNSUCCESSFUL: 'UNSUCCESSFUL',
    ERROR: 'ERROR'
} as const;
export type GetInterviewsListReportResult = typeof GetInterviewsListReportResult[keyof typeof GetInterviewsListReportResult];
/**
 * @export
 */
export const GetRecruitmentResultsReportPeriod = {
    WEEK: 'week',
    MONTH: 'month',
    QUARTER: 'quarter',
    YEAR: 'year',
    ALL: 'all'
} as const;
export type GetRecruitmentResultsReportPeriod = typeof GetRecruitmentResultsReportPeriod[keyof typeof GetRecruitmentResultsReportPeriod];


